export const GET_EXTRACTION_INSTRUCTIONS = "GET_EXTRACTION_INSTRUCTIONS";
export const GET_EXTRACTION_INSTRUCTION = "GET_EXTRACTION_INSTRUCTION";
export const DELETE_EXTRACTION_INSTRUCTION = "DELETE_EXTRACTION_INSTRUCTION";
export const ENSURE_EXTRACTION_INSTRUCTION = "ENSURE_EXTRACTION_INSTRUCTION";
